import { useCallback, useState } from "react"

// The page a server-paged table is on, back to 1 whenever anything else in its query changes:
// a narrower window, a new sort or a new search would otherwise leave the table on a page that
// no longer exists. `query` is a memoised value that changes identity with everything the
// request depends on apart from the page. The reset is derived, not set, so a query change
// costs one request rather than one for the old page and another for page 1.
export const usePageOf = (query) => {
  const [state, setState] = useState({ query, page: 1 })
  const page = state.query === query ? state.page : 1
  const setPage = useCallback((next) => setState({ query, page: next }), [query])
  return [page, setPage]
}
